<div class="payment-process-info-content">
  <p>
    Le dépôt d'une étude ne déclenche <b>aucun paiement immédiat</b>. Le montant correspondant est
    ajouté à votre abonnement Stripe, comme une ligne supplémentaire du mois en cours.
  </p>

  <p>
    Au <b>début du mois suivant</b>, Stripe prélève en une seule fois le montant total de l'abonnement,
    incluant l'ensemble des études déposées le mois précédent, sur le moyen de paiement enregistré sur cette page.
  </p>

  <p>
    Une étude peut ne pas être facturée si elle est <b>annulée avant ce prélèvement</b> et qu'aucune lecture
    n'a encore été effectuée.
  </p>

  <p class="security-note">
    Vos données bancaires sont chiffrées et traitées exclusivement par Stripe (certifié PCI DSS Niveau 1) ;
    elles ne sont ni connues ni stockées sur nos serveurs.
  </p>
</div>
